import React from 'react'
import { FEATURE_ID } from '../../../Common/constant'
import ConstructionImage from "../../../assets/images/industry/construction.png"
import EducationImage from "../../../assets/images/industry/education.png"
import EngineeringImage from "../../../assets/images/industry/engineering.png"
import InfrastructureImage from "../../../assets/images/industry/infrastructure.png"
import LogisticImage from "../../../assets/images/industry/logistic.png"
import ManufacturingImage from "../../../assets/images/industry/manufacturing.png"
import MedicalImage from "../../../assets/images/industry/medical.png"
import MilitaryImage from "../../../assets/images/industry/military.png"
import MiningImage from "../../../assets/images/industry/mining.png"
import OilGasImage from "../../../assets/images/industry/oil-gas.png"
import RealEstateImage from "../../../assets/images/industry/real-estate.png"
import SupplyChainImage from "../../../assets/images/industry/supply-chain.png"
import TelcoImage from "../../../assets/images/industry/telco.png"
import TrainingImage from "../../../assets/images/industry/training.png"
import TransportationImage from "../../../assets/images/industry/transportation.png"

const Industry = () => {
    const industries = [
        { id: 1, title: "Mining", data_aos_delay: "0ms", image: MiningImage },
        { id: 2, title: "Oil & Gas", data_aos_delay: "200ms", image: OilGasImage },
        { id: 3, title: "Transportation", data_aos_delay: "400ms", image: TransportationImage },
        { id: 4, title: "Military", data_aos_delay: "600ms", image: MilitaryImage },
        { id: 5, title: "Manufacturing", data_aos_delay: "800ms", image: ManufacturingImage },
        { id: 6, title: "Supply Chain", data_aos_delay: "1000ms", image: SupplyChainImage },
        { id: 7, title: "Telco", data_aos_delay: "1200ms", image: TelcoImage },
        { id: 8, title: "Infrastructure", data_aos_delay: "1400ms", image: InfrastructureImage },
        { id: 9, title: "Construction", data_aos_delay: "1600ms", image: ConstructionImage },
        { id: 10, title: "Real Estate", data_aos_delay: "1800ms", image: RealEstateImage },
        { id: 11, title: "Medical", data_aos_delay: "2000ms", image: MedicalImage },
        { id: 12, title: "Engineering", data_aos_delay: "2200ms", image: EngineeringImage },
        { id: 13, title: "Logistic", data_aos_delay: "2400ms", image: LogisticImage },
        { id: 14, title: "Training", data_aos_delay: "2600ms", image: TrainingImage },
        { id: 15, title: "Education", data_aos_delay: "2800ms", image: EducationImage }
    ]

    return (
        <section id={FEATURE_ID.INDUSTRY} className="service__section p_relative see__pad">
            <div className="auto-container">
                <div className="service__data">
                    <div className="title__data">
                        <div className="title">
                            <h2>Explore Our Industries</h2>
                        </div>
                    </div>
                    <div className="industry__block__wrapper">
                        {industries.map((item) => (
                            <div className="wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={item.id}>
                                <div className="industry__block">
                                    <div className="industry__icon">
                                        <img src={item.image} alt={item.title.toLowerCase()} />
                                    </div>
                                    <div className="industry__text">
                                        <button><h4>{item.title}</h4></button>
                                    </div>
                                </div>
                            </div>
                        )
                        )}
                    </div>
                    {/* <div className="row">
                        {industries.map((item, id) => (
                            <div className="col-lg-3 col-sm-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={id}>
                                <div className="service__block">
                                    <div className="service__icon">
                                        <i className="icon-04"></i>
                                    </div>
                                    <div className="service__text">
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        )
                        )}
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default Industry